class Environment {
  static readonly Names = class {
    static readonly Dev: string = 'local';
    static readonly Production: string = 'production';
  };

  static readonly Languages = class {
    static readonly EN_CA: string = 'en-CA';
    static readonly FR_CA: string = 'fr-CA';
  };
}

export default Environment;
